import { ReactNode, useMemo } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import useWindowSize from "../../../utils/useWindowSize";
import styles from "./ImageSlider.module.scss";

interface Props {
  children: ReactNode;
  isCenter: boolean;
  numItems?: number;
}

interface ArrowProps {
  onClick?: () => void;
}

function CarouselArrow({
  direction,
  onClick,
}: ArrowProps & { direction: "left" | "right" }) {
  return (
    <button
      aria-label={direction === "left" ? "Previous slide" : "Next slide"}
      className={`${styles.carouselArrow} ${
        styles[`carouselArrow${direction === "left" ? "Left" : "Right"}`]
      }`}
      onClick={onClick}
      type="button"
    >
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d={direction === "left" ? "m15 18-6-6 6-6" : "m9 18 6-6-6-6"} />
      </svg>
    </button>
  );
}

export default function DetailSlider({ children, isCenter, numItems }: Props) {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: numItems ? numItems : 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: numItems ? numItems : 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: numItems ? numItems : 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: numItems ? numItems : 1,
    },
  };
  const isCarousel = useMemo(() => {
    return children instanceof Array && children.length > 1;
  }, [children]);
  const window = useWindowSize();

  return isCarousel ? (
    <Carousel
      ssr={true}
      centerMode={isCenter}
      infinite={true}
      itemClass={styles["carousel-item-padding"]}
      responsive={responsive}
      showDots={false}
      customLeftArrow={<CarouselArrow direction="left" />}
      customRightArrow={<CarouselArrow direction="right" />}
      beforeChange={() => {
        if (typeof document !== "undefined") {
          const video = document.querySelector("video");
          if (video) video.pause();
        }
      }}
    >
      {children}
    </Carousel>
  ) : (
    <div
      style={{
        height: "100%",
        width: "100%",
        position: "relative",
        minHeight: window.width < 839 ? "30vh" : "50vh",
        boxSizing: "border-box",
        maxHeight: "650px",
      }}
    >
      <div
        style={{
          display: "block",
          overflow: "hidden",
          position: "absolute",
          inset: "0px",
          boxSizing: "border-box",
          margin: "0px",
          width: "100%",
          height: "100%",
        }}
      >
        {children}
      </div>
    </div>
  );
}
